import { Loading } from 'src/components'

import { ContentContainerProps } from './contentContainer.types'

const ContentContainer = ({ isLoading, children, isError, errorChild }: ContentContainerProps) => {
  if (isLoading) {
    return <Loading />
  }

  if (isError && errorChild) {
    return <>{errorChild}</>
  }

  return <>{children}</>
}

export default ContentContainer
